module.exports = __webpack_public_path__ + "static/img/ks.a69022d3.png";